import { register } from "react-native-bundle-splitter";
export default register({ loader: () => import("./Statements") });
